export default {"giftCard":"CMRTN","boxClose":"VcKxS","closeGift":"aT3mC","content":"_4hBvG"};